import { colors, fontSizes, fontWeights, lineHeights, spacings, responsiveBreakPoints } from '@styles/DesignVariables';
import styled from 'styled-components';
const { maxTablet } = responsiveBreakPoints;

export const RatingBox = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	text-align: center;
	padding: ${spacings.s12} ${spacings.s24};
	background: ${colors.whiteBackground};
	border-radius: 15px;
	border: 2px solid ${colors.grey700};
	gap: ${spacings.s4};
	@media screen and (${maxTablet}) {
		padding: ${spacings.s6} ${spacings.s16};
	}
`;

export const RatingHeading = styled.h4`
	color: #333;
	font-size: ${fontSizes.heroBoxHeading};
	line-height: ${lineHeights.heroBoxHeading};
	font-weight: ${fontWeights.bold};
	@media screen and (${maxTablet}) {
		font-size: 14px;
	}
`;

export const RatingImages = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	gap: ${spacings.s6};
	@media screen and (${maxTablet}) {
		gap: ${spacings.s4};
	}

	img {
		height: ${spacings.s16};
		@media screen and (${maxTablet}) {
			&:last-of-type {
				max-width: 68px;
				height: auto;
			}
			&:first-of-type {
				max-width: 32px;
				height: auto;
			}
		}
	}
`;
export const RatingText = styled.p`
	color: ${colors.paragraphText};
	font-size: 14px;
	line-height: ${lineHeights.smallParagraph};
	font-weight: ${fontWeights.normal};
	@media screen and (${maxTablet}) {
		font-size: 10px;
		line-height: 130%;
	}
`;
